import { render, staticRenderFns } from "./techprocessesTable.vue?vue&type=template&id=f8f6aae2&scoped=true&"
import script from "./techprocessesTable.vue?vue&type=script&lang=js&"
export * from "./techprocessesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8f6aae2",
  null
  
)

export default component.exports